/**
 * WordPress dependencies
 */
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

export default function save({ attributes }) {
    const {
        countSlides,
        arrows,
        dots,
        infinite,
        slidesToShow,
        slidesToScroll,
        speed,
        fade,
        autoplay,
        autoplaySpeed,
        cssEase,
    } = attributes;
    const settings = {
        "rows": 0,
        "arrows": arrows,
        "dots": dots,
        "infinite": infinite,
        "speed": speed,
        "fade": fade,
        "autoplay": autoplay,
        "autoplaySpeed": autoplaySpeed,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "cssEase": cssEase,
    }
    return (
        <div {...useBlockProps.save()}>
            <div className="slick-slider-wrap" data-slick={`${JSON.stringify(settings)}`}>
                <InnerBlocks.Content/>
            </div>
        </div>
    );
}